import { Code } from '.';

export const CustomCode = Code.extend({
   addKeyboardShortcuts() {
      return {
         'Mod-e': () => this.editor.commands.toggleCode(),
         'Mod-`': () => this.editor.commands.toggleCode(),
      };
   },
   // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'string | ((... Remove this comment to see the full error message
   excludes: null,
   priority: 200,
});
